<template>
  <div id="unit-detail">
    <section class="bg-grey pb-4 pb-lg-5">
      <div class="container">
        <div class="row">
          <div class="col-12 py-lg-5">
            <div class="d-none d-lg-block">
              <span class="text-grey"
                >{{ $t("menu.home") }} I {{ $t("menu.unit") }} I</span
              >
              {{ data["projectName_" + $i18n.locale] }}
              {{ $t("pages.roomNo") }} {{ data.roomNo }}
            </div>
          </div>
          <div class="col-12 mt-3 mt-lg-0 pb-3 pb-lg-5">
            <h4>
              <b>{{ data["projectName_" + $i18n.locale] }}</b>
            </h4>
          </div>
        </div>
      </div>
      <div class="container-fluid pb-3 pb-lg-5 d-none d-lg-block">
        <div class="row">
          <div class="col-12">
            <div class="px-5">
              <div class="next">
                <i
                  class="fas fa-chevron-left cursor-pointer"
                  @click="nextPrevSlideImage('prve')"
                ></i>
              </div>
              <slick ref="slideImages" :options="slideOptions">
                <img
                  :src="item"
                  class="px-2"
                  v-for="(item, i) in data.photo"
                  :key="i"
                  @click="openModalImages()"
                />
              </slick>
              <div class="prev">
                <i
                  class="fas fa-chevron-right cursor-pointer"
                  @click="nextPrevSlideImage('next')"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-8 pr-lg-5">
            <div class="row pr-lg-5">
              <div class="col-12 mb-3 mb-lg-0">
                <div class="prohot-detail d-lg-none float-left">HOT DEAL</div>
                <div class="d-lg-none float-right pt-2">
                  <b @click="openModalImages()">
                    {{ $t("pages.allImages") }}
                    <i class="fas fa-plus-circle"></i>
                  </b>
                </div>
              </div>
              <div class="col-12">
                <div class="float-left">
                  <h5>
                    <b>{{ data["title_" + $i18n.locale] }}</b>
                  </h5>
                  <h6>
                    <b>{{ $t("pages.roomNo") }} : {{ data.roomNo }}</b>
                  </h6>
                </div>
                <div class="float-right d-none d-lg-block">
                  <div class="prohot-detail">HOT DEAL</div>
                </div>
              </div>
              <div class="col-12">
                <img src="./../../assets/images/icon/marker.png" class="mr-2" />
                {{ data["zone_" + $i18n.locale] }}
              </div>
              <div class="col-12 py-4">
                <div class="float-left mr-5">
                  {{ $t("pages.bahtMonth") }}
                  <br />
                  <b>
                    {{ data.priceRental | numFormat }}
                    {{ $t("pages.baht") }}
                  </b>
                </div>
                <div class="float-left">
                  {{ $t("pages.area") }}
                  <br />
                  <b>{{ data.floorArea }} {{ $t("pages.sqm") }}</b>
                </div>
              </div>
              <div class="col-12">
                <div>
                  {{ $t("pages.building") }} : {{ data.building }} I
                  {{ $t("pages.floor") }} : {{ data.floorLevel }} I
                  {{ $t("pages.facing") }} :
                  {{ data["facing_" + $i18n.locale] }}
                </div>
                <div class="pt-3">
                  {{ data["description_" + $i18n.locale] }}
                </div>
              </div>
              <div class="col-12 pt-4">
                <div class="facility-section">
                  <div class="facility-item border-right pr-3">
                    <i class="sprite icon-bed mr-2"></i>
                    <div class="facility-number">{{ data.bedRoom }}</div>
                  </div>
                  <div class="facility-item">
                    <i class="sprite icon-bath mr-2"></i>
                    <div class="facility-number">{{ data.bathRoom }}</div>
                  </div>
                  <!-- <div class="facility-item">
                    <img src="./../../assets/images/icon/bts.png">
                  </div>-->
                </div>
              </div>
              <div class="col-12 pt-5" v-if="data.projectFacilities">
                <h5>
                  <b>{{ $t("pages.unitFacilities") }}</b>
                </h5>
                <div class="facility-list row">
                  <div
                    class="text-bottom-wrapper facility-item-list col-3 col-lg-2 text-center"
                    v-for="(item, i) in data.projectFacilities"
                    :key="i"
                  >
                    <div
                      v-b-tooltip.hover
                      :title="item['projectFacilities_' + $i18n.locale]"
                      v-if="item"
                    >
                      <img :src="getImageProject(item.code)" height="35" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 pt-5" v-if="data.roomAmenities">
                <h5>
                  <b>{{ $t("pages.unitAmenities") }}</b>
                </h5>
                <div class="facility-list row">
                  <div
                    class="text-bottom-wrapper facility-item-list col-3 col-lg-2 text-center"
                    v-for="(item, i) in data.roomAmenities"
                    :key="i"
                  >
                    <div
                      v-b-tooltip.hover
                      :title="item['roomAmenities_' + $i18n.locale]"
                    >
                      <img :src="getImageRoom(item.code)" height="35" />
                    </div>
                  </div>
                </div>
                <div class="position-relative w-100 float-left d-lg-none mt-3">
                  <div class="float-left mr-2">
                    <b>{{ $t("pages.unitLocation") }}</b> :
                  </div>
                  <div class="float-left border-fac fs-15">
                    <a :href="googleMap" target="_blank">
                      <b>{{ $t("pages.unitGoogleMap") }}</b>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <form
              class="border bg-white float-left w-100 d-none d-lg-block"
              @submit.stop.prevent="onSubmit"
              v-if="!userInfo"
            >
              <div class="pt-4 pl-4 pr-4">
                <h5 class="text-center">
                  <b>{{ $t("pages.unitInterested") }}</b>
                </h5>
                <b-form-input
                  id="firstName"
                  name="firstName"
                  v-model="form.firstName"
                  v-validate="{ required: true }"
                  :state="validateState('firstName')"
                  v-bind:placeholder="$t('pages.unitName')"
                ></b-form-input>
                <b-form-input
                  id="lastName"
                  class="mt-3"
                  name="lastName"
                  v-model="form.lastName"
                  v-validate="{ required: true }"
                  :state="validateState('lastName')"
                  v-bind:placeholder="$t('pages.unitLastName')"
                ></b-form-input>
                <b-form-input
                  id="email"
                  class="mt-3"
                  name="email"
                  v-model="form.email"
                  v-validate="{ required: true, email: true }"
                  :state="validateState('email')"
                  v-bind:placeholder="$t('pages.unitEmail')"
                ></b-form-input>
                <b-form-input
                  id="mobile"
                  class="mt-3"
                  name="mobile"
                  v-model="form.mobile"
                  v-validate="{ required: true, min: 10 }"
                  :state="validateState('mobile')"
                  v-bind:placeholder="$t('pages.unitPhone')"
                ></b-form-input>
                <b-form-checkbox
                  class="mt-3"
                  id="checkedTerm"
                  v-model="form.checkedTerm"
                  name="checkedTerm"
                  value="accepted"
                  unchecked-value
                  v-validate="{ required: true }"
                  :state="validateState('checkedTerm')"
                >
                  <u>{{ $t("pages.unitAgree") }}</u>
                </b-form-checkbox>
                <div class="text-center mt-3">
                  <button class="btn btn-primary" type="submit">
                    {{ $t("pages.unitSubmit") }}
                  </button>
                </div>
              </div>
              <div class="mt-4 border-top">
                <div class="float-left p-3 border-right" style="width: 75%">
                  <router-link to="/register">
                    <b>{{ $t("pages.unitAgentRegis") }}</b>
                  </router-link>
                </div>
                <div class="float-left p-3 text-center" style="width: 25%">
                  <img src="./../../assets/images/icon/arrow-right.png" />
                </div>
              </div>
            </form>
            <!-- <div class="block-user-info d-none d-lg-block" v-if="userInfo">
              <div
                class="border-bottom p-3 w-100 float-left row-userinfo"
                @click="downloadImage(data.zipPhoto)"
              >
                <div class="float-left">ดาวน์โหลดรูปภาพ</div>
                <div class="float-right">
                  <img src="./../../assets/images/icon/download.png" width="20" />
                </div>
              </div>
              <div
                class="border-bottom p-3 w-100 float-left row-userinfo"
                @click="openModal($route.params.id)"
              >
                <div class="float-left">แชร์ยูนิตนี้</div>
                <div class="float-right">
                  <img src="./../../assets/images/icon/share.png" width="20" />
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </section>
    <section class="py-5 d-none d-lg-block">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="float-left mr-2">
              <b>{{ $t("pages.unitLocation") }}</b> :
            </div>
            <div class="float-left border-fac fs-15">
              <a :href="googleMap" target="_blank">
                <b>{{ $t("pages.unitGoogleMap") }}</b>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container">
        <div class="row">
          <div class="col-12 pb-4 pb-lg-0">
            <form
              class="border bg-white float-left w-100 d-block d-lg-none"
              @submit.stop.prevent="onSubmit"
              v-if="!userInfo"
            >
              <div class="pt-4 pl-4 pr-4">
                <h5 class="text-center">
                  <b>{{ $t("pages.unitInterested") }}</b>
                </h5>
                <b-form-input
                  id="firstName"
                  name="firstName"
                  v-model="form.firstName"
                  v-validate="{ required: true }"
                  :state="validateState('firstName')"
                  v-bind:placeholder="$t('pages.unitName')"
                ></b-form-input>
                <b-form-input
                  id="lastName"
                  class="mt-3"
                  name="lastName"
                  v-model="form.lastName"
                  v-validate="{ required: true }"
                  :state="validateState('lastName')"
                  v-bind:placeholder="$t('pages.unitLastName')"
                ></b-form-input>
                <b-form-input
                  id="email"
                  class="mt-3"
                  name="email"
                  v-model="form.email"
                  v-validate="{ required: true, email: true }"
                  :state="validateState('email')"
                  v-bind:placeholder="$t('pages.unitEmail')"
                ></b-form-input>
                <b-form-input
                  id="mobile"
                  class="mt-3"
                  name="mobile"
                  v-model="form.mobile"
                  v-validate="{ required: true, min: 10 }"
                  :state="validateState('mobile')"
                  v-bind:placeholder="$t('pages.unitPhone')"
                ></b-form-input>
                <b-form-checkbox
                  class="mt-3"
                  id="checkedTerm"
                  v-model="form.checkedTerm"
                  name="checkedTerm"
                  value="accepted"
                  unchecked-value
                  v-validate="{ required: true }"
                  :state="validateState('checkedTerm')"
                >
                  <u>{{ $t("pages.unitAgree") }}</u>
                </b-form-checkbox>
                <div class="text-center mt-3">
                  <button class="btn btn-primary" type="submit">
                    {{ $t("pages.unitSubmit") }}
                  </button>
                </div>
              </div>
              <div class="mt-4 border-top">
                <div class="float-left p-3 border-right" style="width: 75%">
                  <router-link to="/register">
                    <b>{{ $t("pages.unitAgentRegis") }}</b>
                  </router-link>
                </div>
                <div class="float-left p-3 text-center" style="width: 25%">
                  <img src="./../../assets/images/icon/arrow-right.png" />
                </div>
              </div>
            </form>
            <!-- <div class="block-user-info d-block d-lg-none" v-if="userInfo">
              <div
                class="border-bottom p-3 w-100 float-left row-userinfo"
                @click="downloadImage(data.zipPhoto)"
              >
                <div class="float-left">ดาวน์โหลดรูปภาพ</div>
                <div class="float-right">
                  <img src="./../../assets/images/icon/download.png" width="20" />
                </div>
              </div>
              <div
                class="border-bottom p-3 w-100 float-left row-userinfo"
                @click="openModal($route.params.id)"
              >
                <div class="float-left">แชร์ยูนิตนี้</div>
                <div class="float-right">
                  <img src="./../../assets/images/icon/share.png" width="20" />
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </section>
    <section>
      <b-modal id="modal-save" centered>
        <template v-slot:modal-header="{ close }">
          <h2 class="text-right w-100 mb-0">
            <img
              src="./../../assets/images/icon/close.png"
              width="25"
              class="cursor-pointer"
              @click="close()"
            />
          </h2>
        </template>

        <template v-slot:default>
          <div class="text-center" v-html="msgSave"></div>
          <div class="text-center">
            <router-link to="/" tag="button" class="btn btn-primary mt-2 mb-5"
              >กลับหน้าหลัก</router-link
            >
          </div>
        </template>
      </b-modal>
    </section>
    <section>
      <b-modal id="modal-scoped" centered>
        <template v-slot:modal-header="{ close }">
          <h2 class="text-right w-100 mb-0">
            <img
              src="./../../assets/images/icon/close.png"
              width="25"
              class="cursor-pointer"
              @click="close()"
            />
          </h2>
        </template>
        <template v-slot:default>
          <div class="text-center">
            <div>
              <img src="./../../assets/images/icon/success.png" />
            </div>
            <div class="pt-2">Link Copied</div>
            <div class="py-4">
              <input
                type="text"
                class="form-control"
                :value="link"
                readonly
                id="link"
              />
            </div>
            <button
              class="btn btn-primary mb-4 text-uppercase"
              @click="copyLink()"
            >
              <b>Copy</b>
            </button>
          </div>
        </template>
      </b-modal>
    </section>
    <section>
      <b-modal id="modal-images" centered size="xl">
        <template v-slot:modal-header="{ close }">
          <h2 class="text-right w-100 mb-0">
            <img
              src="./../../assets/images/icon/close.png"
              @click="close()"
              class="cursor-pointer"
              width="25"
            />
          </h2>
        </template>
        <template v-slot:default>
          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <div class="px-5 mb-4">
                  <slick
                    ref="slick1"
                    :options="slickOptions1"
                    class="slider-for"
                  >
                    <img
                      :src="item"
                      height="500"
                      v-for="(item, i) in data.photo"
                      :key="i"
                    />
                  </slick>
                </div>
              </div>
              <div class="col-12">
                <div class="float-left" style="width: 82%">
                  <slick
                    ref="slick2"
                    :options="slickOptions2"
                    @afterChange="handleAfterChange"
                    class="slider-nav"
                  >
                    <img
                      :src="item"
                      height="100"
                      v-for="(item, i) in data.photo"
                      :key="i"
                    />
                  </slick>
                </div>
                <div class="text-right mt-3 float-left" style="width: 18%">
                  <div
                    class="count-slide mr-3 position-relative"
                    style="right: -9px; top: -6px"
                  >
                    <div class="d-inline text-blue position-relative">
                      <b>{{ currentSlide }}</b>
                    </div>
                    <div class="d-inline">
                      <img
                        src="./../../assets/images/icon/slash.png"
                        height="50"
                      />
                    </div>
                    <div
                      class="text-grey d-inline position-relative"
                      style="top: 10px; left: -10px"
                    >
                      <b>{{ data.photo.length }}</b>
                    </div>
                  </div>
                  <div class="arrow-slide" @click="prev()">
                    <div class="arrow-left">
                      <i class="icon-slide-left"></i>
                    </div>
                    <div class="arrow-right" @click="next()">
                      <i class="icon-slide-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </b-modal>
    </section>
  </div>
</template>

<script>
import Slick from "vue-slick";
export default {
  components: {
    Slick,
  },
  data() {
    return {
      data: Object,
      googleMap: "",
      form: {
        firstName: null,
        lastName: null,
        email: null,
        mobile: null,
        checkedTerm: "",
      },
      msgSave: "",
      userInfo: JSON.parse(localStorage.getItem("agenthub-info")),
      link: "",
      slideOptions: {
        slidesToShow: 4,
        arrows: false,
        infinite: true,
        centerMode: true,
        centerPadding: "60px",
      },
      slickOptions1: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: ".slider-nav",
      },
      slickOptions2: {
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: ".slider-for",
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        arrows: false,
      },
      currentSlide: 1,
    };
  },
  mounted() {
    this.getDetail();
  },
  beforeUpdate() {
    if (this.$refs.slideImages) {
      this.$refs.slideImages.destroy();
    }
  },
  updated() {
    this.$nextTick(() => {
      if (this.$refs.slideImages) {
        this.$refs.slideImages.create(this.slideOptions);
      }
    });
  },
  methods: {
    getDetail() {
      const checkUserInfo = this.userInfo ? this.userInfo.userID : 0;
      this.$http
        .get(
          this.$app.baseURL +
            this.$path.getPropDetail +
            "/" +
            this.$route.params.id +
            "?userID=" +
            checkUserInfo
        )
        .then((res) => {
          const data = res.data.data[0];
          if (data.roomAmenities) {
            data.roomAmenities = data.roomAmenities.split(",");
            data.roomAmenities_TH = data.roomAmenities_TH.split(",");
            data.roomAmenities_EN = data.roomAmenities_EN.split(",");
            let roomAmenities = [];
            data.roomAmenities.forEach((item, i) => {
              roomAmenities.push({
                code: item.trim(),
                roomAmenities_TH: data.roomAmenities_TH[i].trim(),
                roomAmenities_EN: data.roomAmenities_EN[i].trim(),
              });
            });
            data.roomAmenities = roomAmenities;
            console.log("roomAmenities==>", roomAmenities);
          }
          if (data.projectFacilities) {
            data.projectFacilities = data.projectFacilities.split(",");
            data.projectFacilities_TH = data.projectFacilities_TH.split(",");
            data.projectFacilities_EN = data.projectFacilities_EN.split(",");
            let projectFacilities = [];
            data.projectFacilities.forEach((item, i) => {
              projectFacilities.push({
                code: item.trim(),
                projectFacilities_TH: data.projectFacilities_TH[i].trim(),
                projectFacilities_EN: data.projectFacilities_EN[i].trim(),
              });
            });
            data.projectFacilities = projectFacilities;
            console.log("projectFacilities==>", projectFacilities);
          }
          this.data = data;
          this.googleMap =
            "http://maps.google.com/?q=" +
            this.data.location_Lat +
            "," +
            this.data.location_Long;
        });
    },
    validateState(ref) {
      if (
        this.$veeFields[ref] &&
        (this.$veeFields[ref].dirty || this.$veeFields[ref].validated)
      ) {
        return !this.$veeErrors.has(ref);
      }
      return null;
    },
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        let loading = this.$loading.show();
        const formData = new FormData();
        formData.append("firstName", this.form.firstName);
        formData.append("lastName", this.form.lastName);
        formData.append("email", this.form.email);
        formData.append("mobile", this.form.mobile);
        formData.append("interesPropID", 0);
        this.$http
          .post(this.$app.baseURL + this.$path.customerRegister, formData)
          .then(
            (res) => {
              loading.hide();
              this.$bvModal.show("modal-save");
              if (res.data.status == 200) {
                this.msgSave =
                  '<h4><b>ขอบคุณ</b></h4><div class="py-4">คุณได้ทำการลงทะเบียน กับ Rental Agentcloud<br><b> ทาง Rental Agentcloud จะติดต่อกลับคุณไปทางอีเมลที่คุณ<br>ได้ทำการลงทะเบียนไว้ เพื่อยืนยันการลงทะเบียนที่สมบูรณ์</b></div>';
              } else {
                this.msgSave =
                  '<h4><b>คุณไม่สามารถลงทะเบียนได้</b></h4><div class="py-4">เนื่องจาก Account นี้ได้มีการลงทะเบียนไว้แล้ว<br>หรือ Account นี้กำลังรอการยืนยันการลงทะเบียนอย่างสมบูรณ์จากทางเจ้าหน้าที่</div>';
              }
              this.resetForm();
            },
            () => {
              loading.hide();
              this.$bvModal.show("modal-save");
              this.msgSave =
                '<h4><b>คุณไม่สามารถลงทะเบียนได้</b></h4><div class="py-4">เนื่องจาก Account นี้ได้มีการลงทะเบียนไว้แล้ว<br>หรือ Account นี้กำลังรอการยืนยันการลงทะเบียนอย่างสมบูรณ์จากทางเจ้าหน้าที่</div>';
              this.resetForm();
            }
          );
      });
    },
    resetForm() {
      this.form = {
        firstName: null,
        lastName: null,
        email: null,
        mobile: null,
        checkedTerm: "",
      };
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },
    openModal(value) {
      const formData = new FormData();
      formData.append("PropID", value);
      formData.append("userID", this.userInfo ? this.userInfo.userID : 0);
      this.$http.post(this.$app.baseURL + this.$path.addShareLog, formData);
      this.link = window.location.origin + "/unit-detail/" + value;
      this.$bvModal.show("modal-scoped");
    },
    copyLink() {
      const formData = new FormData();
      formData.append("PropID", this.$route.params.id);
      formData.append("userID", this.userInfo ? this.userInfo.userID : 0);
      this.$http.post(this.$app.baseURL + this.$path.addCopyLog, formData);
      let inputLink = document.querySelector("#link");
      inputLink.select();
      try {
        document.execCommand("copy");
        // const successful = document.execCommand('copy');
        // const msg = successful ? 'successful' : 'unsuccessful';
        // alert('Testing code was copied ' + msg);
      } catch (err) {
        // alert('Oops, unable to copy');
      }
      window.getSelection().removeAllRanges();
    },
    openModalImages() {
      this.$bvModal.show("modal-images");
    },
    nextPrevSlideImage(action) {
      if (action == "next") {
        this.$refs.slideImages.next();
      } else {
        this.$refs.slideImages.prev();
      }
    },
    next() {
      this.$refs.slick2.next();
    },

    prev() {
      this.$refs.slick2.prev();
    },
    handleAfterChange(event, slick, currentSlide) {
      this.currentSlide = currentSlide + 1;
    },
    getImageProject(img) {
      return require(`./../../assets/images/unit/icon/project/${img}.png`);
    },
    getImageRoom(img) {
      return require(`./../../assets/images/unit/icon/room/${img}.png`);
    },
    downloadImage(link) {
      const formData = new FormData();
      formData.append("PropID", this.$route.params.id);
      formData.append("userID", this.userInfo ? this.userInfo.userID : 0);
      this.$http.post(this.$app.baseURL + this.$path.addDownloadLog, formData);
      const splitLink = link.split("\\");
      const joinLink = splitLink.join("/");
      const anchor = document.createElement("a");
      anchor.href = this.$app.domain + joinLink;
      anchor.target = "_blank";
      anchor.download = splitLink[2];
      anchor.click();
    },
  },
};
</script>

<style scoped>
.block-user-info {
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);
  background: #fff;
  width: 100%;
  position: relative;
  float: left;
}

.row-userinfo:hover {
  background: #ebf9fd;
  cursor: pointer;
}

.prev {
  font-size: 34px;
  position: absolute;
  right: 25px;
  top: 40%;
}
.next {
  font-size: 34px;
  position: absolute;
  left: 25px;
  top: 40%;
}
</style>